import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="gradient-overlay"></div>
      <div className="floating-accent"></div>
      
      <Header />
      
      <main className="about-main-content">
        <section className="about-hero-section">
          <div className="about-hero-content">
            <h1 className="about-hero-title">About Us</h1>
            <p className="about-hero-subtitle">Connecting exceptional brands with discerning customers</p>
          </div>
        </section>
        
        <section className="about-content-section">
          <div className="about-info-card">
            <div className="about-info-content">
              <h2>DMB Brands</h2>
              <p>
                DMB Brands is a leading distributor of exceptional lifestyle and home products, 
                carefully curating brands that represent quality, innovation, and timeless design. 
                Based in Worcester, we've been connecting remarkable brands with discerning customers 
                across the UK for years.
              </p>
              
              <p>
                Our portfolio includes internationally renowned brands such as Elvang, Gefu, Remember, 
                Rader, PPD, Relaxound, and My Flame Lifestyle. Each brand in our collection is chosen 
                for its commitment to excellence, unique design philosophy, and ability to enhance 
                everyday living.
              </p>

              <p>
                From luxurious textiles to innovative kitchen solutions, from beautiful stationery 
                to calming sound products, we bring together a diverse range of products that share 
                common values: quality craftsmanship, thoughtful design, and the power to transform 
                ordinary moments into something special.
              </p>

              <div className="about-values">
                <div className="value-item">
                  <h3>Quality</h3>
                  <p>We partner only with brands that meet our high standards for craftsmanship and durability.</p>
                </div>
                
                <div className="value-item">
                  <h3>Innovation</h3>
                  <p>Our brands push boundaries and bring fresh perspectives to traditional product categories.</p>
                </div>
                
                <div className="value-item">
                  <h3>Design</h3>
                  <p>Beautiful, functional design is at the heart of everything we represent.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;